import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Renderiza shapes do Zabbix: retangulos, elipses, texto.
 * type: 0=rectangle, 1=ellipse, 2=line, 3=text
 */
export default memo(({ data }) => {
  const {
    shapeType = 0,
    width = 100,
    height = 50,
    text = '',
    font_size = 11,
    font_color = '000000',
    background_color = '',
    border_type = 0,
    border_color = '000000',
    border_width = 1,
  } = data;

  const bgColor = background_color ? `#${background_color}` : 'transparent';
  const txtColor = font_color ? `#${font_color}` : '#000';
  const brdColor = border_color ? `#${border_color}` : '#000';

  const borderStyle = border_type === 0 ? 'none'
    : border_type === 1 ? 'solid'
    : border_type === 2 ? 'dotted'
    : border_type === 3 ? 'dashed'
    : 'solid';

  // Text-only shape
  if (shapeType === 3) {
    return (
      <Box sx={{
        width,
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}>
        <Typography
          sx={{
            fontSize: font_size,
            color: txtColor,
            whiteSpace: 'pre-wrap',
            textAlign: 'center',
            lineHeight: 1.2,
          }}
        >
          {text}
        </Typography>
      </Box>
    );
  }

  // Rectangle or Ellipse
  return (
    <Box sx={{
      width,
      height,
      backgroundColor: bgColor,
      border: border_type > 0 ? `${border_width}px ${borderStyle} ${brdColor}` : 'none',
      borderRadius: shapeType === 1 ? '50%' : 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      overflow: 'hidden',
    }}>
      {text && (
        <Typography
          sx={{
            fontSize: font_size,
            color: txtColor,
            whiteSpace: 'pre-wrap',
            textAlign: 'center',
            lineHeight: 1.2,
            px: 0.5,
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
});
